import React from "react";
import styles from './Footer.module.scss';

export default function Footer() {
  return (
    <>
      <footer role="contentinfo">
        <div className={styles['region-footer']}>
          <div className={styles['block-footer-block']}>
            <a className={styles.num} href="https://www.netzwerk-universitaetsmedizin.de/" target="_blank"
               rel="noreferrer">
              <img src={process.env.PUBLIC_URL + "/NUM-Logo-New.png"} alt="" />
            </a>
            <a className={styles.bmbf} href="https://www.bmbf.de/" target="_blank" rel="noreferrer">
              <img src={process.env.PUBLIC_URL + "/BMFTR_gefoerdert_durch.png"} alt="" />
            </a>
          </div>
        </div>
      </footer>
    </>
  )
}